const props = props => ({
  noRowsRenderer: () => props.emptyMessage,
  onChangePagination: ({ selected }) => {
    props.setCurrentPage(selected)
    window.scroll(0, 0)
  },
  onSort ({ setSortDirection, setSortIndex, setSortText, sortBy, sortDirection, sortIndex }) {
    if (props.onSort) {
      props.setSortBy(sortBy)
      props.setSortDirection(sortDirection)
      props.onSort({
        setSortDirection,
        setSortIndex,
        setSortText,
        sortBy,
        sortDirection,
        sortIndex
      })
    }
  }
})

export default props
